<template>
  <div>Edit Awards</div>
</template>

<script>
export default {};
</script>